<template>
  <div class="act_layout">
    <div class="lv_flexalign_center">
      <div style="margin-right: 5px">亮&nbsp;&nbsp;&nbsp;度</div>
      <van-slider
        class="lv_flex_1"
        v-model="brightness"
        @input="handleInput1"
        @change="handleChange1"
        bar-height="4px"
        inactive-color="#999"
        active-color="#6e9f21"
        :min="0"
        :max="200"
      />
      <div class="slider_text">{{ brightness }}</div>
    </div>
    <div class="lv_flexalign_center">
      <div style="margin-right: 5px">对比度</div>
      <van-slider
        class="lv_flex_1"
        v-model="contrast"
        @input="handleInput2"
        @change="handleChange2"
        bar-height="4px"
        inactive-color="#999"
        active-color="#6e9f21"
        :min="0"
        :max="200"
      />
      <div class="slider_text">{{ contrast }}</div>
    </div>
    <div class="lv_flexalign_center">
      <div style="margin-right: 5px">饱和度</div>
      <van-slider
        class="lv_flex_1"
        v-model="saturation"
        @input="handleInput3"
        @change="handleChange3"
        bar-height="4px"
        inactive-color="#999"
        active-color="#6e9f21"
        :min="0"
        :max="200"
      />
      <div class="slider_text">{{ saturation }}</div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      brightness: 100,
      contrast: 100,
      saturation: 100,
      id: null,
    };
  },
  methods: {
    init(item) {
      console.log(item, "item");
      this.id = item.id;
      this.brightness = item.brightness || 100;
      this.contrast = item.contrast || 100;
      this.saturation = item.saturation || 100;
    },
    handleInput1() {
      this.$bus.$emit("setBrightness", this.brightness);
    },
    handleChange1() {
      this.$bus.$emit("setBrightness", this.brightness);
    },
    handleInput2() {
      this.$bus.$emit("setContrast", this.contrast);
    },
    handleChange2() {
      this.$bus.$emit("setContrast", this.contrast);
    },
    handleInput3() {
      this.$bus.$emit("setSaturation", this.saturation);
    },
    handleChange3() {
      this.$bus.$emit("setSaturation", this.saturation);
    },
  },
};
</script>

<style>
</style>